import React from 'react';
import { StructuredTaskPanel } from '../../../../common/components/StructuredTaskDetails';
import { TaskHeader } from '../../../../common/components/TaskHeader';
import { DocumentType } from '../../../../common/constants/documentType';
import { Resource } from '../../../../common/constants/resource';
import { TaskState } from '../../../../common/constants/states';
import ElementLocators from '../../../../common/ElementLocators';
import { ITask } from '../../../tasks/interfaces/ITask';
import { MIB } from '../../../tasks/types/mib';
import { factsExist } from '../../utilities/taskDetailUtilities';
import { RetryableEvidenceItem } from '../components/RetryableEvidenceItem';
import { RenderMIBApplicant } from './MIBApplicant';
import { MIBResponses } from './MIBResponses';

export const MIBDetail = ({
  task,
  retryHandler,
  markOutdatedHandler,
  uploadHandler,
  downloadHandler,
  taskStateHandler,
  deleteHandler,
}: {
  task: ITask;
  retryHandler: (taskId: number) => void;
  markOutdatedHandler: (taskId: number) => void;
  uploadHandler: (
    existingTaskData: ITask,
    data: FormData,
    type: string,
  ) => void;
  downloadHandler: (uri: string, fileName: string) => void;
  deleteHandler: (
    existingTaskData: ITask,
    documentId: number,
    reason: string,
  ) => void;
  taskStateHandler: (taskId: number, state: TaskState, reason?: string) => void;
}) => {
  const { evidence } = task;

  function renderTaskDetails() {
    const mib: MIB | null = evidence ? (evidence.facts as MIB) : null;
    if (!mib) {
      return <></>;
    }

    return (
      <>
        {mib && !mib.recordExists && !evidence?.errorMessage && (
          <p>{Resource.MIB_NO_RECORD}</p>
        )}
        {mib.recordExists && (
          <StructuredTaskPanel>
            <TaskHeader title={Resource.TASK_TITLE_MIB} />
            <>
              <RenderMIBApplicant />
              <MIBResponses sections={mib.sections} />
            </>
          </StructuredTaskPanel>
        )}
      </>
    );
  }

  return (
    <div data-label={ElementLocators.LOCATOR_MIB_SECTION}>
      <RetryableEvidenceItem
        task={task}
        documentType={DocumentType.MIB}
        title={Resource.TASK_TITLE_MIB}
        downloadHandler={downloadHandler}
        uploadHandler={uploadHandler}
        deleteHandler={deleteHandler}
        retryHandler={retryHandler}
        taskStateHandler={taskStateHandler}
        markOutdatedHandler={markOutdatedHandler}
      >
        {factsExist(evidence) ? renderTaskDetails() : <></>}
      </RetryableEvidenceItem>
    </div>
  );
};
